<template>
    <div class="form-content">
      <div class="home-header">
        <!-- 微信认证组件 -->
        <wxAuth :share="share"></wxAuth>
        <!-- title -->
        <headers :params="hraderP"></headers>
        <div class="minew">
          <div @click="nimeColor = true" :class="{'color1':nimeColor,'color2':!nimeColor}">我的需求</div>
          <div @click="nimeColor = false" :class="{'color1':!nimeColor,'color2':nimeColor}">我的定制方案</div>
        </div>
      </div>
      <!-- <div class="h24"></div> -->
	  <div style="height:60px;background: #EFEFF4;" v-if="!isNativeApp"></div>
	  <div style="height: 2.7rem;background: #EFEFF4;" v-if="isNativeApp"></div>
      <div v-if="nimeColor">
        <needlist></needlist>
      </div>
      <div v-if="!nimeColor">
        <mycase></mycase>
      </div>
    </div>
</template>

<script>
import headers from '@/components/headerslf'
import wxAuth from '@/components/wxAuth'
import mycase from '@/view/userPerson/mycase'
import needlist from '@/view/userPerson/needlist'
export default {
  name: 'add-demand-form',
  components: { wxAuth, headers ,mycase,needlist},
  data () {
    return {
      share: {
        title: '解决方案馆',
        desc: '智能化产品方案,产品方案,系统方案,弱电设备方案,厂商方案,产品供应商设计方案,弱电设计方案,热门方案,规划设计方案,顶层设计方案,系统解决方案,集成商方案,招标方案,投标方案,深化设计方案,施工方案',
        imgUrl: 'https://image01.homedo.com/Files/Images/cms/www/20171225/4970465306687879653_pic1.jpg',
        url: window.location.href.split('#')[0]
      },
      hraderP: {
        title: '需求管理',
        lefticon: true
      },
      nimeColor:true,
      isNativeApp:false
    }
  },
  created(){
     this.isNativeApp = !(($HMD$.rNavigator && ($HMD$.rNavigator.toLowerCase() === 'ios' || $HMD$.rNavigator.toLowerCase() === 'android')))
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.form-content{
  // background: #FFF;
  padding-bottom: 20px;
  .home-header{
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 9;
  }
  .h24{
    height: 120px;
    background: #EFEFF4;
  }
  .minew{
    width: 100%;
    background: #ffffff;
    display: flex;
    justify-content:space-between;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 16px;
    box-sizing: border-box;
    div{
      width: 48%;
      height:44px;
      line-height: 44px;
      font-weight: bold;
    }
    .color1{
      color: #2177FF;
      border-bottom:2px solid  #2F7BFF;

    }
    .color2{
      color: #6D6D6D;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/userPerson/userPerson.vue